import * as Type from './actionsTypes';

const INITIAL_STATE = {
  selectedJornada: {},
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case Type.FETCH_JORNADA_SUCCESS:
    case Type.SAVE_JORNADA_SUCCESS:
    case Type.JORNADA_VALIDATE_SUCCESS: {
      return {
        ...state,
        selectedJornada: action.data,
      };
    }
    case Type.CLEAR_SELECTED_JORNADA: {
      return {
        ...state,
        selectedJornada: {},
      };
    }
    case Type.CLEAR_JORNADA: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
}

export const getSelectedJornada = state => state.rootState.jornada.selectedJornada;
